import { useHistory } from 'react-router-dom'

import { Button, makeStyles, Tooltip } from '@material-ui/core'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import { ReactComponent as DeleteIcon } from 'assets/icons/outlined-bin.svg'

import { ConfirmationDialog } from 'UI/Components'

import { useBoolean } from 'hooks'
import { deletePlaybook, capitalize, logToAnalytics } from 'modules'

import { paths } from 'app/paths'
import { PlaybookType } from 'app/types'

type Props = {
    id: string
    title: string
    mode: PlaybookType['mode']
    smallDeleteButton?: boolean
}

const useStyles = makeStyles({
    outlinedBtn: {
        minWidth: '40px !important'
    }
})

export const Delete = ({ id, title, mode, smallDeleteButton }: Props) => {
    const classes = useStyles()

    const history = useHistory()
    const showDialog = useBoolean()

    const target = mode === 'playlist' ? 'playlist' : 'video'

    return (
        <>
            {smallDeleteButton ? (
                <Tooltip title="Delete">
                    <Button
                        variant="outlined"
                        style={{
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF',
                            padding: ' 10px',
                            height: '32px'
                        }}
                        classes={{
                            outlined: classes.outlinedBtn
                        }}
                        onClick={showDialog.setTrue}
                    >
                        <DeleteIcon fontSize="small" />
                    </Button>
                </Tooltip>
            ) : (
                <Button
                    color="default"
                    style={{ height: 32, color: 'black' }}
                    onClick={showDialog.setTrue}
                    title="Delete"
                    startIcon={<DeleteOutlineIcon />}
                >
                    Delete
                </Button>
            )}

            <ConfirmationDialog
                isOpen={showDialog.isTrue}
                onClose={showDialog.setFalse}
                onConfirm={() => {
                    deletePlaybook(id)
                    showDialog.setFalse()
                    history.push(paths.myVideos)
                    logToAnalytics('delete_playbook', {
                        playbookType: mode
                    })
                }}
                title={`Delete ${capitalize(target)}`}
                text={
                    <>
                        Are you sure you want to delete <b>{title}</b>?
                    </>
                }
                confirmBtnText="Delete"
            />
        </>
    )
}
